import React, { useState } from 'react'
import Select from 'react-select'
import { ToolTipUIForModal } from '../UI/ToolTipUIForModal'
import { ToolTipUI } from '../UI/ToolTipUI'
import { useThemeMode } from '../../../../../_metronic/partials'

interface DropdownOption {
  readonly name: string
  readonly id: number
  readonly value: string
}

interface GroupedOption {
  readonly label: string
  readonly options: readonly DropdownOption[]
}

const formatGroupLabel = (data: GroupedOption) => (
  <div>
    <span>{data.label}</span>
  </div>
)
interface SelectHeaderDropDownProps {
  fieldName?: string
  label?: string
  margin?: string
  width?: number
  formik?: any
  isTooltipNotRequired?: boolean
  isStarRequired?: boolean
  isTooltipForModal?: boolean
  toolTipText?: string
  placeholder?: string
  dropdownOptions?: any
  disabled?: boolean
}

const SelectHeaderDropDown: React.FC<SelectHeaderDropDownProps> = ({
  fieldName,
  label,
  margin,
  width,
  isTooltipNotRequired = false,
  isStarRequired = false,
  isTooltipForModal = false,
  toolTipText = '',
  placeholder,
  formik,
  dropdownOptions,
  disabled
}) => {
  const [selectedOptions, setSelectedOptions] = useState<any>(null) // eslint-disable-line
  const { mode } = useThemeMode()
  const handleChange = (selectedOptions: any) => {
    setSelectedOptions(selectedOptions)
    formik.setFieldValue(fieldName, selectedOptions)
  }
  const selectedValue = fieldName && formik.values[fieldName]

  const customStyles = {
    group: (provided: any) => ({
      ...provided,
      borderBottom: '1px solid #ddd',
      paddingBottom: '10px',
    }),
    groupHeading: (provided: any) => ({
      ...provided,
      fontSize: '13px',
      padding: '5px 11px',
      paddingTop: '0px',
    }),
    control: (provided: any) => ({
      ...provided,
      boxShadow: 'none',
      borderRadius: "0.5rem",
      border: `${formik.touched && formik.errors
        ? mode === 'dark' ? 'none' : '1px solid #ddd'
        : formik.touched && !formik.errors
          ? '1px solid #50cd89'
          : mode === 'dark'
            ? 'none'
            : '1px solid #ddd'
        }`,
      '&:hover': {
        border: `${formik.touched && formik.errors
          ? mode === 'dark' ? 'none' : '1px solid #ddd'
          : formik.touched && !formik.errors
            ? '1px solid #50cd89'
            : mode === 'dark'
              ? 'none'
              : '1px solid #ddd'
          }`,
      },
      background: `${formik.touched && formik.errors && fieldName
        ? formik.touched[fieldName] && formik.errors[fieldName]
          ? 'rgba(241, 65, 108, 0.2)'
          : formik.touched[fieldName] && !formik.errors[fieldName]
            ? 'white'
            : mode === 'dark'
              ? '#181c32'
              : disabled
                ? '#eff2f5'
                : 'white'
        : 'white'
        }`,
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontSize: '12px',
      color: '#a1a5b7',
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: mode === 'dark' ? '#181c32' : 'white',
      borderRadius: '0.5rem',
    }),
    option: (provided: any, state: { isFocused: boolean; isSelected: boolean }) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? (mode === 'dark' ? '#3f434d' : '#e9ecef')
        : state.isSelected
          ? (mode === 'dark' ? '#3f434d' : '#f1f1f1')
          : 'transparent',
      color: state.isSelected || state.isFocused
        ? (mode === 'dark' ? 'white' : 'black')
        : mode === 'dark'
          ? '#a1a5b7'
          : 'black',
      fontSize: '12px',
      padding: '8px 12px',
    }),
  };


  return (
    <div className={`fv-row mb-7 ${margin ? margin : ''} ${width ? `col-md-${width}` : ''}`}>
      {label && (
        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
          {label}
          {!isTooltipNotRequired && (
            <>
              {!isStarRequired && '*'}
              {isTooltipForModal ? (
                <ToolTipUIForModal tooltipText={toolTipText} />
              ) : (
                <ToolTipUI tooltipText={toolTipText} />
              )}
            </>
          )}
        </label>
      )}
      <div className=''><Select<DropdownOption, false, GroupedOption>
        // defaultValue={dropdownOptions[0].options[0]}
        options={dropdownOptions}
        value={selectedValue}
        formatGroupLabel={formatGroupLabel}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.value}
        styles={customStyles}
        placeholder={placeholder}
        onChange={handleChange}
        isDisabled={disabled}
      /></div>
    </div>
  )
}

export default SelectHeaderDropDown
